module.exports = __webpack_public_path__ + "media/images/pc/plans/search_form/costume_type_both_costume-0538c303dd9f68a69beca0c323a4a88b.webp";